import React, {useState} from 'react';
import Dropzone, {DropzoneRootProps, DropzoneInputProps} from 'react-dropzone';
import {Box, Stack, Tooltip, Typography} from "@mui/material";
import {styles} from "../../../common/style";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";

function FileList(props: {fileNameList: string[], fileUrlList: string[]}) {
    console.log('FileList');

    function download(fileName: string) {
        console.log('FileList - download');
        const serverUrl = process.env.REACT_APP_SERVER_URL || '';

        window.open(`${serverUrl}${fileName}`, '_blank');
    }

    return (
        <Stack sx={{width: 1}}>
            <Stack sx={{display: props.fileNameList.length > 0 ? '' : 'none', p: 1, borderTop: styles.border}}>
                {props.fileNameList.map((fileName: string, index: number) => (
                    <Button key={index}
                            onClick={() => download(props.fileUrlList[index])}
                            size={"small"}
                            sx={{display: 'flex', justifyContent: 'flex-start'}}>
                        <Typography sx={{}}>
                            {index + 1}) {fileName}
                        </Typography>
                    </Button>
                ))}
            </Stack>
        </Stack>
    );
}

export default FileList;